import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Api from "../../../../lib/componentApi";
//import Loading from "../../../../components/Common/Loading";
import getOrderStatusForTrack, {
  allStatus
} from "../../../../lib/getOrderStatusForTrack";
import moment from "moment";
import { useFirebaseForTrack } from "../../../../utils/hooks/firebase";
import { getDistance } from "../../../../utils/google";
var configs = require("../../../../../public/config");

const NotTracking = () => {
  return (
    <div className="order-tracking__info">
      <h4>Delivered by Coocina Burgers</h4>
      <p>Unfortunately you can't track your order as a result.</p>
      <span className="color-blue">#gigeconomy</span>
      <p className="color-blue">
        Here at Local E we want to help care for our drivers. That’s why we give
        all our driver’s the opportunity to work with us on an hourly basis.
      </p>
    </div>
  );
};

const OrderTrackScreen = ({ match }) => {
  const { orderUid } = match.params;
  const [order, setOrder] = useState(null);
  const { trackData } = useFirebaseForTrack(orderUid);
  const [map, setMap] = useState(null);
  const [polyline, setPolyline] = useState(null);
  const [bounds, setBounds] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [descriptionData, setDescriptionData] = useState(null);
  const getOrder = () => {
    Api.post("/api/order", { orderUid }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-order");
      } else {
        if (response.status) {
          setOrder(response);
        }
      }
    });
  };
  useEffect(() => {
    if (trackData.status) {
      const { status } = trackData;
      handleOrderStatus(status);
      if (status === "ORDER_IN_DRIVER") {
        polyline.setMap(null);
        getOrder();
      } else if (status === "ORDER_COMPLETED") {
        markers.filter(Boolean).map(marker => marker.setMap(null));
        polyline.setMap(null);
        createMap(map, bounds, "ORDER_COMPLETED");
      }
    }
  }, [trackData.status]);

  const location = trackData.location || { lat: null, lon: null };
  useEffect(() => {
    if (location.lat && location.lon) {
      if (trackData.status === "ORDER_IN_DRIVER") {
        const distance = getDistance(
          order.address.lat,
          order.address.lon,
          location.lat,
          location.lon
        );
        console.log("distance:", distance);
        markers.filter(Boolean).map(marker => marker.setMap(null));
        if (distance < configs.orderTrackingInAddressDistance) {
          handleOrderStatus("IN_ADDRESS");
          getMarkers(map, polyline, bounds, "IN_ADDRESS");
        } else {
          getMarkers(map, polyline, bounds, "ORDER_IN_DRIVER");
        }
      } else if (trackData.status !== "ORDER_COMPLETED") {
        console.log("no driver");
        markers.filter(Boolean).map(marker => marker.setMap(null));
        getMarkers(map, polyline, bounds, "");
      }
    }
  }, [location.lat, location.lon]);

  useEffect(() => {
    if (!map && order) {
      directionCalc(order.deliveryDriver);
    }
  }, [map, order]);

  const getMarkers = (map, polyline, bounds, status) => {
    let markers = [];
    if (status === "ORDER_COMPLETED" || status === "IN_ADDRESS") {
      if (status === "ORDER_COMPLETED") {
        const homeCoord = new google.maps.LatLng(
          order.address.lat,
          order.address.lon
        );

        let bounds = new google.maps.LatLngBounds();
        bounds.extend(homeCoord);
        map.fitBounds(bounds);
        markers = [
          new google.maps.Marker({
            //Start
            position: homeCoord,
            map,
            icon: new google.maps.MarkerImage(
              // URL
              "/svg/home-icon.svg",
              // (width,height)
              new google.maps.Size(48, 69)
            )
          })
        ];
      } else {
        const driverCoord = new google.maps.LatLng(
          trackData.location.lat,
          trackData.location.lon
        );
        const homeCoord = polyline.getPath().getAt(0);
        let bounds = new google.maps.LatLngBounds();
        bounds.extend(homeCoord);
        bounds.extend(driverCoord);
        map.fitBounds(bounds);
        markers = [
          new google.maps.Marker({
            //Start
            position: polyline.getPath().getAt(0),
            map,
            icon: new google.maps.MarkerImage(
              // URL
              "/svg/home-icon.svg",
              // (width,height)
              new google.maps.Size(48, 69)
            )
          }),
          new google.maps.Marker({
            position: driverCoord,
            map,
            icon: new google.maps.MarkerImage(
              // URL
              "/svg/driver-icon.svg",
              // (width,height)
              new google.maps.Size(48, 69)
            )
          }),
          new google.maps.Marker({
            //End
            position: polyline
              .getPath()
              .getAt(polyline.getPath().getLength() - 1),
            map,
            icon: new google.maps.MarkerImage(
              // URL
              "/svg/restaurant-icon.svg",
              // (width,height)
              new google.maps.Size(48, 69)
            )
          })
        ];
      }
    } else {
      const coord =
        (trackData.location && {
          lat: trackData.location.lat,
          lon: trackData.location.lon
        }) ||
        null;
      markers = [
        new google.maps.Marker({
          //Start
          position: polyline.getPath().getAt(0),
          map,
          icon: new google.maps.MarkerImage(
            // URL
            "/svg/home-icon.svg",
            // (width,height)
            new google.maps.Size(48, 69)
          )
        }),
        new google.maps.Marker({
          //End
          position: polyline
            .getPath()
            .getAt(polyline.getPath().getLength() - 1),
          map,
          icon: new google.maps.MarkerImage(
            // URL
            "/svg/restaurant-icon.svg",
            // (width,height)
            new google.maps.Size(48, 69)
          )
        }),
        coord &&
          coord.lat &&
          coord.lon &&
          new google.maps.Marker({
            position: new google.maps.LatLng(coord.lat, coord.lon),
            map,
            icon: new google.maps.MarkerImage(
              // URL
              "/svg/driver-icon.svg",
              // (width,height)
              new google.maps.Size(48, 69)
            )
          })
      ];
    }
    setMarkers(markers);
    return markers;
  };

  const createMapWithDirections = (map, polyline, bounds, routes) => {
    var legs = routes[0].legs;
    for (let i = 0; i < legs.length; i++) {
      var steps = legs[i].steps;

      for (let j = 0; j < steps.length; j++) {
        var nextSegment = steps[j].polyline;
        const paths = google.maps.geometry.encoding.decodePath(
          nextSegment.points
        );
        for (let k in paths) {
          if (
            typeof paths[k].lat === "function" &&
            typeof paths[k].lng === "function"
          ) {
            const data = new google.maps.LatLng(paths[k].lat(), paths[k].lng());
            polyline.getPath().push(data);
            bounds.extend(data);
          }
        }
      }
    }
    polyline.setMap(map);
    map.fitBounds(bounds);
    const markers = getMarkers(map, polyline);
    markers.filter(Boolean).map(marker => marker.setMap(map));
  };
  const createMap = (map, bounds, status) => {
    const markers = getMarkers(map, null, bounds, status);
    markers.filter(Boolean).map(marker => marker.setMap(map));
  };

  const directionCalc = deliveryDriver => {
    const customer = order.address;
    const restaurant = order.restaurant.address;
    const customerLat = customer.lat;
    const customerLon = customer.lon;
    const restaurantLat = restaurant.lat;
    const restaurantLon = restaurant.lon;
    const driverLocation = (deliveryDriver && {
      lat: deliveryDriver.lat,
      lon: deliveryDriver.lon
    }) || { lat: null, lon: null };
    console.log(driverLocation, "direction calc");
    var map = new google.maps.Map(document.getElementById("track-map"), {
      center: new google.maps.LatLng(customerLat, customerLon),
      zoom: 10,
      disableDefaultUI: true,
      maxZoom: 19,
      zoomControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    var noPoi = [
      {
        featureType: "poi",
        stylers: [{ visibility: "off" }]
      }
    ];
    map.setOptions({ styles: noPoi });
    var polyline = new google.maps.Polyline({
      path: [],
      strokeColor: "#1fb6ff",
      strokeWeight: 5
    });
    var bounds = new google.maps.LatLngBounds();
    setMap(map);
    setPolyline(polyline);
    setBounds(bounds);
    if (
      trackData.status === "ORDER_COMPLETED" ||
      order.status === "ORDER_COMPLETED"
    ) {
      markers.filter(Boolean).map(marker => marker.setMap(null));
      createMap(map, bounds, "ORDER_COMPLETED");
    } else {
      Api.post(
        "/api/directions",
        {
          customerLat,
          customerLon,
          restaurantLat,
          restaurantLon,
          driverLocation
        },
        (response, errors) => {
          if (errors) {
            console.log(errors);
            throw new Error(errors);
          } else if (response.code) {
            console.log(response);
            throw new Error(response);
          } else {
            if (response.status === "OK") {
              createMapWithDirections(map, polyline, bounds, response.routes);
            } else {
              console.error(
                `error fetching directions ${JSON.stringify(response)}`
              );
            }
          }
        }
      );
    }
  };

  const handleOrderStatus = orderStatus => {
    const currentStatusId = getOrderStatusForTrack(orderStatus);
    const deliveryType = (order && order.restaurantDeliveryType) || "";
    console.log("delivery type:", deliveryType);
    const currentStatus = allStatus.find(
      status => status.id === currentStatusId
    );
    if (!currentStatus || deliveryType !== "THIRD_PARTY_DELIVERY") {
      window.location.href = `/profile?orders#${orderUid}`;
    } else {
      setDescriptionData(currentStatus);
    }
  };

  useEffect(() => {
    if (order) {
      handleOrderStatus(order.status);
    }
  }, [order]);

  useEffect(() => {
    if (!order) {
      getOrder();
    }
  }, [order]);

  const getDriverName = order => {
    if (order && order.deliveryDriver) {
      return `${order.deliveryDriver.firstName} ${order.deliveryDriver.lastName}`;
    } else {
      return ``;
    }
  };
  const getDriverPhone = order => {
    if (order && order.deliveryDriver) {
      return `${order.deliveryDriver.mobileNumber}`;
    } else {
      return ``;
    }
  };

  const getRestaurantPhone = order => {
    if (order && order.restaurant) {
      return order.restaurant.contactMobileNumber;
    } else {
      return ``;
    }
  };
  return (
    <div className="order-tracking white-bg">
      <a
        href="/profile?orders"
        className="d-flex align-items-center justify-content-center back-orders hide-xs"
      >
        <i className="icon icon-arrow-left rotate" />
        <span>Back to your orders</span>
      </a>
      {(descriptionData && order && (
        <div className="order-tracking__body">
          <div className="visible-xs mobile">
            <div className="head d-flex justify-content-between">
              <div>
                <h4>{descriptionData.title}</h4>
                <p>
                  {order.address.addressLine1}, {order.address.addressLine2},{" "}
                  {order.address.postalCode}
                </p>
              </div>
              <div>
                <a href="/profile?orders" className="icon icon-close"></a>
              </div>
            </div>

            <div className="empty-maps" />

            <div className="body">
              <div className="circle">
                <img
                  style={{
                    width: "39px",
                    height: "45px"
                  }}
                  src={descriptionData.icon}
                ></img>
              </div>
              <div className="text">
                <p className="time">
                  Estimated time:{" "}
                  {moment(order.orderEarliestDeliveryDeadline).format("HH:mm")}{" "}
                  - {moment(order.orderLatestDeliveryDeadline).format("HH:mm")}
                </p>
              </div>
            </div>
            {descriptionData.inRestaurant && (
              <div className="mobile-phone d-flex align-items-center justify-content-between">
                <p>{order.restaurant.name}</p>
                <div>
                  <a href={`tel:${getRestaurantPhone(order)}`}>
                    <img src="/svg/phone-blue.svg" />
                  </a>
                </div>
              </div>
            )}
            {descriptionData.inDriver && (
              <div className="mobile-phone d-flex align-items-center justify-content-between">
                <p>{getDriverName(order)}</p>
                <div>
                  <a href={`tel:${getDriverPhone(order)}`}>
                    <img src="/svg/phone-blue.svg" />
                  </a>
                </div>
              </div>
            )}
          </div>

          <div className="hide-xs">
            <div className="circle">
              <img
                style={{
                  width: "39px",
                  height: "45px"
                }}
                src={descriptionData.icon}
              ></img>
            </div>
            <div className="text">
              <h4>{descriptionData.title}</h4>
              <p className="address">
                {order.address.addressLine1}, {order.address.addressLine2},{" "}
                {order.address.postalCode}
              </p>
              <p className="time">
                Estimated time:{" "}
                {moment(order.orderEarliestDeliveryDeadline).format("HH:mm")} -{" "}
                {moment(order.orderLatestDeliveryDeadline).format("HH:mm")}
              </p>
            </div>

            <div className="hide-xs">
              {descriptionData.inRestaurant && (
                <div className="order-tracking__phone">
                  <img src="/svg/phone.svg" />
                  <p>{order.restaurant.name}</p>
                  <p className="bold">{order.restaurant.contactMobileNumber}</p>
                </div>
              )}
              {descriptionData.inDriver && (
                <div className="order-tracking__phone">
                  <img src="/svg/phone.svg" />
                  <p>{getDriverName(order)}</p>
                  <p className="bold">{getDriverPhone(order)}</p>
                </div>
              )}
            </div>
          </div>
          <div className="order-tracking__line">
            <div className={`d-flex active-${descriptionData.id}`}>
              <div>
                <h5>Preparing</h5>
                <span></span>
              </div>
              <div>
                <h5>On its way</h5>
                <span></span>
              </div>
              <div>
                <h5>Near you</h5>
                <span></span>
              </div>
              <div className="d-flex">
                <h5>Completed</h5>
                <span></span>
              </div>
            </div>
          </div>
          {/*<NotTracking />*/}
        </div>
      )) || <noscript />}
      <div className="order-tracking-map">
        <div id="track-map" />
      </div>
    </div>
  );
};

export default withRouter(OrderTrackScreen);
